// src/components/auth/AdminRoute.tsx
// Only admins (isAdmin: true) can access this route.
// Non-admins → main app. Not authenticated → /login.
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { RootState } from 'store';

export default function AdminRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated, isInitializing, user } = useSelector((s: RootState) => s.auth);

  if (isInitializing) {
    return (
      <div className="fixed inset-0 flex items-center justify-center bg-[var(--om-app)]">
        <div className="w-8 h-8 border-2 border-blue-500 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (!isAuthenticated) return <Navigate to="/login" replace />;
  if (!user?.isAdmin)   return <Navigate to="/" replace />;

  return <>{children}</>;
}
